var map = {
	"./asset-hyperlink.json": 7885,
	"./blockquote.json": 6442,
	"./document.json": 8071,
	"./embedded-asset-block.json": 6241,
	"./embedded-entry-block.json": 6649,
	"./embedded-entry-inline.json": 8477,
	"./embedded-resource-block.json": 8119,
	"./embedded-resource-inline.json": 3703,
	"./entry-hyperlink.json": 1297,
	"./heading-1.json": 5018,
	"./heading-2.json": 6507,
	"./heading-3.json": 8920,
	"./heading-4.json": 2465,
	"./heading-5.json": 8470,
	"./heading-6.json": 4839,
	"./hr.json": 7828,
	"./hyperlink.json": 9156,
	"./list-item.json": 3110,
	"./ordered-list.json": 2658,
	"./paragraph.json": 1944,
	"./resource-hyperlink.json": 1313,
	"./table-cell.json": 4013,
	"./table-header-cell.json": 4599,
	"./table-row.json": 2247,
	"./table.json": 8234,
	"./text.json": 4957,
	"./unordered-list.json": 133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4789;